<div class="flex min-h-screen flex-col">
  <app-topbar-menu />

  <main class="min-w-0 flex-1 p-4">
    <router-outlet />
  </main>

  <app-footer />
</div>
